var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIronIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_241_8886)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6.01172C19.84 6.01172 18.5 7.35429 18.5 9.01747V13.0251C18.5 13.5762 18.05 14.0271 17.5 14.0271V10.0194C17.5 8.35621 16.16 7.01364 14.5 7.01364H10.5C8.84 7.01364 7.5 8.35621 7.5 10.0194H9.5C9.5 9.46833 9.95 9.01747 10.5 9.01747H14.5C15.05 9.01747 15.5 9.46833 15.5 10.0194V11.0213H6.5C4.29 11.0213 2.5 12.8147 2.5 15.029V18.0347H17.5V16.0309C19.16 16.0309 20.5 14.6883 20.5 13.0251V9.01747C20.5 8.46642 20.95 8.01555 21.5 8.01555H22.5V6.01172H21.5ZM15.5 16.0309H4.5V15.029C4.5 13.9269 5.4 13.0251 6.5 13.0251H15.5V16.0309Z",
    fill: "#494949"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_241_8886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.046,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIronIcon);
export default __webpack_public_path__ + "static/media/IronIcon.8b2224347b7692bb3bd3a917b8d6e209.svg";
export { ForwardRef as ReactComponent };